import React from 'react';
import classNames from 'classnames';

import ContentCarousel from 'rebook/apps/base/components/ContentCarousel';
import BooksetHorizontalCardEmpty from 'rebook/apps/catalog/components/BooksetHorizontalCardEmpty';

import styles from './style.scss';


const BooksetListEmpty = () => (
  <div className={classNames(styles.containerEmpty, 'billetContainerNoOverflow')}>
    <div className={styles.titleEmpty} />
    <ContentCarousel>
      {[...Array(5)].map((bookset, i) => (
        <BooksetHorizontalCardEmpty extraClassName="swiper-slide" key={i} />
      ))}
    </ContentCarousel>
  </div>
);

export default BooksetListEmpty;
